import { render, staticRenderFns } from "./DatabaseAdminPage.vue?vue&type=template&id=2082b292&scoped=true&"
import script from "./DatabaseAdminPage.vue?vue&type=script&lang=js&"
export * from "./DatabaseAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2082b292",
  null
  
)

export default component.exports